// GENERATED by apps/api/scripts/build-scoring-model.ts from
// gpu_server_health_scoring_full_v5_scoring_rules.csv — do not edit by hand.
// Moved from apps/api/src/scoring/models/telemetry-scoring.v5.ts (RUF-514) so
// apps/telemetry-ingest's nightly recompute can import the model through
// @siliconx/shared (apps only depend on each other via shared).
import type { ScoringModel } from '../engine.js';

export const telemetryScoringModel: ScoringModel = {
  "modelVersion": "v5",
  "source": "gpu_server_health_scoring_full_v5_scoring_rules.csv",
  "rules": [
    {
      "telemetryName": "GPU_Count_Detected",
      "parentFeature": "GPU_Detection_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "ExpectedGPUCount",
      "goodThreshold": 8,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "Must match expected GPU count"
    },
    {
      "telemetryName": "GPU_Model",
      "parentFeature": "GPU_Context",
      "parentCategory": "GPU_Health",
      "fieldWeight": 10,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "GPU_UUID",
      "parentFeature": "Evidence_Correlation",
      "parentCategory": "GPU_Health",
      "fieldWeight": 10,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_PCI_Bus_ID",
      "parentFeature": "Evidence_Correlation",
      "parentCategory": "GPU_Health",
      "fieldWeight": 40,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Driver_Version",
      "parentFeature": "GPU_Context",
      "parentCategory": "GPU_Health",
      "fieldWeight": 10,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_VBIOS_Version",
      "parentFeature": "GPU_Context",
      "parentCategory": "GPU_Health",
      "fieldWeight": 10,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ECC_Mode_Current",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 30,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "ECC_Mode_Pending",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "ECC_Correctable_Volatile",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ECC_Correctable_Aggregate",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ECC_Uncorrectable_Volatile",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ECC_Uncorrectable_Aggregate",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Retired_Pages_Single_Bit",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Retired_Pages_Double_Bit",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Pending_Retired_Pages",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Row_Remap_Count",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Row_Remap_Failure_Count",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ECC_Correctable_Growth_Rate",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ECC_Uncorrectable_Growth_Rate",
      "parentFeature": "GPU_Memory_Reliability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_XID_Event_Count",
      "parentFeature": "GPU_Fault_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 25,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Critical_XID_Count",
      "parentFeature": "GPU_Fault_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Last_XID_Code",
      "parentFeature": "GPU_Fault_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Last_XID_Timestamp",
      "parentFeature": "GPU_Fault_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Reset_Event_Count",
      "parentFeature": "GPU_Fault_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 25,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Fallen_Off_Bus_Count",
      "parentFeature": "GPU_Fault_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVIDIA_Driver_Load_Failure_Count",
      "parentFeature": "GPU_Fault_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Temperature_Current_C",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 40,
      "ruleMode": "Threshold_High",
      "goodThreshold": 80,
      "criticalThreshold": 90,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Temperature_Max_Observed_C",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Threshold_High",
      "goodThreshold": 80,
      "criticalThreshold": 90,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Memory_Temperature_C",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Threshold_High",
      "goodThreshold": 80,
      "criticalThreshold": 90,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Hotspot_Temperature_C",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Threshold_High",
      "goodThreshold": 80,
      "criticalThreshold": 90,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Thermal_Throttle_Active",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Thermal_Throttle_Count",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Thermal_Violation_Time_Sec",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Temperature_Rise_Rate_C_Per_Min",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 40,
      "ruleMode": "Threshold_High",
      "goodThreshold": 80,
      "criticalThreshold": 90,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Temperature_Recovery_Rate_C_Per_Min",
      "parentFeature": "GPU_Thermal_Health",
      "parentCategory": "GPU_Health",
      "fieldWeight": 40,
      "ruleMode": "Threshold_High",
      "goodThreshold": 80,
      "criticalThreshold": 90,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Power_Draw_Current_W",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Power_Draw_Average_W",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Power_Draw_Peak_W",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Power_Limit_W",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Power_Throttle_Active",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 40,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Power_Throttle_Count",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Reliability_Throttle_Active",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Reliability_Throttle_Count",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_HW_Slowdown_Active",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_HW_Power_Brake_Active",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Power_Draw_Variance_Percent",
      "parentFeature": "GPU_Power_Delivery_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 70,
      "ruleMode": "Threshold_High",
      "goodThreshold": 2,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_SM_Clock_MHz",
      "parentFeature": "GPU_Clock_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Memory_Clock_MHz",
      "parentFeature": "GPU_Clock_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Clock_Variance_Percent",
      "parentFeature": "GPU_Clock_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 75,
      "ruleMode": "Threshold_High",
      "goodThreshold": 2,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Memory_Clock_Variance_Percent",
      "parentFeature": "GPU_Clock_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 75,
      "ruleMode": "Threshold_High",
      "goodThreshold": 2,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Performance_State",
      "parentFeature": "GPU_Clock_Stability",
      "parentCategory": "GPU_Health",
      "fieldWeight": 30,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "GPU_Utilization_Percent",
      "parentFeature": "Validation_Load_Quality",
      "parentCategory": "Validation_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Memory_Utilization_Percent",
      "parentFeature": "Validation_Load_Quality",
      "parentCategory": "Validation_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "GPU_Memory_Used_MB",
      "parentFeature": "Validation_Load_Quality",
      "parentCategory": "Validation_Health",
      "fieldWeight": 25,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_Memory_Free_MB",
      "parentFeature": "Validation_Load_Quality",
      "parentCategory": "Validation_Health",
      "fieldWeight": 25,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "PCIe_Link_Generation_Current",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 30,
      "ruleMode": "Threshold_Low",
      "goodThreshold": 4,
      "criticalThreshold": 2,
      "penaltyPerUnit": 10,
      "scoreDirection": "Higher is better"
    },
    {
      "telemetryName": "PCIe_Link_Generation_Max",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 30,
      "ruleMode": "Threshold_Low",
      "goodThreshold": 4,
      "criticalThreshold": 2,
      "penaltyPerUnit": 10,
      "scoreDirection": "Higher is better"
    },
    {
      "telemetryName": "PCIe_Link_Width_Current",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 30,
      "ruleMode": "Threshold_Low",
      "goodThreshold": 16,
      "criticalThreshold": 8,
      "penaltyPerUnit": 10,
      "scoreDirection": "Higher is better"
    },
    {
      "telemetryName": "PCIe_Link_Width_Max",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 30,
      "ruleMode": "Threshold_Low",
      "goodThreshold": 16,
      "criticalThreshold": 8,
      "penaltyPerUnit": 10,
      "scoreDirection": "Higher is better"
    },
    {
      "telemetryName": "PCIe_Link_Downgrade_Flag",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "PCIe_Replay_Counter",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "PCIe_AER_Correctable_Error_Count",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "PCIe_AER_Uncorrectable_Error_Count",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "PCIe_Link_Retrain_Count",
      "parentFeature": "PCIe_Interconnect_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVLink_Link_State",
      "parentFeature": "GPU_Fabric_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 60,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "NVLink_Link_Down_Count",
      "parentFeature": "GPU_Fabric_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVLink_Error_Count",
      "parentFeature": "GPU_Fabric_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 75,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVSwitch_Health_Status",
      "parentFeature": "GPU_Fabric_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 90,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "DCGM_Overall_Health_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_Memory_Health_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_PCIe_Health_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_NVLink_Health_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_Power_Health_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_Thermal_Health_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_Diagnostic_Overall_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_Memory_Test_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_PCIe_Test_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_Stress_Test_Result",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "DCGM_Policy_Violation_Count",
      "parentFeature": "DCGM_Diagnostic_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "CPU_Health_Status",
      "parentFeature": "CPU_Reliability_Health",
      "parentCategory": "CPU_Health",
      "fieldWeight": 60,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "CPU_Temperature_Current_C",
      "parentFeature": "CPU_Reliability_Health",
      "parentCategory": "CPU_Health",
      "fieldWeight": 45,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "CPU_Temperature_Max_Observed_C",
      "parentFeature": "CPU_Reliability_Health",
      "parentCategory": "CPU_Health",
      "fieldWeight": 45,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "CPU_Thermal_Throttle_Count",
      "parentFeature": "CPU_Reliability_Health",
      "parentCategory": "CPU_Health",
      "fieldWeight": 65,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "CPU_MCE_Count",
      "parentFeature": "CPU_Reliability_Health",
      "parentCategory": "CPU_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 25,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "CPU_Corrected_Error_Count",
      "parentFeature": "CPU_Reliability_Health",
      "parentCategory": "CPU_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "CPU_Uncorrected_Error_Count",
      "parentFeature": "CPU_Reliability_Health",
      "parentCategory": "CPU_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Memory_Health_Status",
      "parentFeature": "DIMM_Reliability_Health",
      "parentCategory": "Memory_Health",
      "fieldWeight": 60,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "DIMM_Correctable_ECC_Count",
      "parentFeature": "DIMM_Reliability_Health",
      "parentCategory": "Memory_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "DIMM_Uncorrectable_ECC_Count",
      "parentFeature": "DIMM_Reliability_Health",
      "parentCategory": "Memory_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Failed_DIMM_Count",
      "parentFeature": "DIMM_Reliability_Health",
      "parentCategory": "Memory_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "DIMM_Predictive_Failure_Count",
      "parentFeature": "DIMM_Reliability_Health",
      "parentCategory": "Memory_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Memory_Sparing_Active",
      "parentFeature": "DIMM_Reliability_Health",
      "parentCategory": "Memory_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVMe_Critical_Warning",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVMe_Media_Error_Count",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 25,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVMe_Percentage_Used",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 75,
      "ruleMode": "Threshold_High",
      "goodThreshold": 20,
      "criticalThreshold": 90,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVMe_Available_Spare_Percent",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 75,
      "ruleMode": "Threshold_Low",
      "goodThreshold": 100,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Higher is better"
    },
    {
      "telemetryName": "NVMe_Available_Spare_Threshold",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 75,
      "ruleMode": "Threshold_Low",
      "goodThreshold": 100,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Higher is better"
    },
    {
      "telemetryName": "NVMe_Unsafe_Shutdown_Count",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 45,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVMe_Power_On_Hours",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "NVMe_Temperature_C",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 45,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVMe_Warning_Temperature_Time",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 75,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NVMe_Critical_Temperature_Time",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 95,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "SATA_Reallocated_Sector_Count",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "SATA_Current_Pending_Sector_Count",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "RAID_Degraded_State",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 95,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "Drive_Predictive_Failure_Count",
      "parentFeature": "Storage_Device_Health",
      "parentCategory": "Storage_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Power_Subsystem_Health",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 60,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "PSU_Health_Status",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 60,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "PSU_Failed_Count",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "PSU_Redundancy_Lost",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 80,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "System_Power_Draw_W",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "System_Power_Peak_W",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "Input_Voltage_Alarm_Count",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 80,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "AC_Loss_Event_Count",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 45,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Power_Event_Count",
      "parentFeature": "Power_Subsystem_Health",
      "parentCategory": "Power_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Thermal_Subsystem_Health",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 60,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "Fan_Health_Status",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 60,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "Fan_Failed_Count",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Fan_Redundancy_Lost",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 85,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Fan_RPM_Min",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "Fan_RPM_Variance_Percent",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 45,
      "ruleMode": "Threshold_High",
      "goodThreshold": 2,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Chassis_Inlet_Temperature_C",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 55,
      "ruleMode": "Threshold_High",
      "goodThreshold": 35,
      "criticalThreshold": 40,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Chassis_Exhaust_Temperature_C",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 55,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Chassis_Delta_T_C",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 55,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Thermal_Alarm_Count",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 90,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 25,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Thermal_Shutdown_Event_Count",
      "parentFeature": "Cooling_Subsystem_Health",
      "parentCategory": "Cooling_Health",
      "fieldWeight": 100,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "System_Health_Status",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 65,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "Chassis_Health_Status",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 65,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "SEL_Total_Event_Count",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "SEL_Critical_Event_Count",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 80,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "SEL_Thermal_Event_Count",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "SEL_Power_Event_Count",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "SEL_Memory_Event_Count",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "SEL_CPU_Event_Count",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Intrusion_Event_Count",
      "parentFeature": "BMC_Event_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Kernel_Panic_Count",
      "parentFeature": "OS_Hardware_Error_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 75,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Last_Kernel_Panic_Timestamp",
      "parentFeature": "OS_Hardware_Error_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 75,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "OOM_Event_Count",
      "parentFeature": "OS_Hardware_Error_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Hardware_Error_Log_Count",
      "parentFeature": "OS_Hardware_Error_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 75,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ACPI_Error_Count",
      "parentFeature": "OS_Hardware_Error_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Corrected_Error_Growth_Rate",
      "parentFeature": "OS_Hardware_Error_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 80,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NIC_Health_Status",
      "parentFeature": "Network_Adapter_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 25,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "NIC_Link_Flap_Count",
      "parentFeature": "Network_Adapter_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 55,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NIC_CRC_Error_Count",
      "parentFeature": "Network_Adapter_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 55,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "NIC_Dropped_Packet_Count",
      "parentFeature": "Network_Adapter_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 25,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "InfiniBand_Link_Error_Count",
      "parentFeature": "Network_Adapter_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 65,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "HCA_Temperature_C",
      "parentFeature": "Network_Adapter_Health",
      "parentCategory": "Interconnect_Health",
      "fieldWeight": 65,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Firmware_Mismatch_Flag",
      "parentFeature": "Firmware_Risk_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "BIOS_Critical_Update_Required",
      "parentFeature": "Firmware_Risk_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "BMC_Critical_Update_Required",
      "parentFeature": "Firmware_Risk_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "GPU_VBIOS_Critical_Update_Required",
      "parentFeature": "Firmware_Risk_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 35,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 1,
      "penaltyPerUnit": 50,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Secure_Boot_State",
      "parentFeature": "Reuse_Readiness_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 15,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "TPM_Health_State",
      "parentFeature": "Reuse_Readiness_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 15,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "Drive_Lock_State",
      "parentFeature": "Reuse_Readiness_Health",
      "parentCategory": "Platform_Health",
      "fieldWeight": 15,
      "ruleMode": "StatusOK",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "OK/Enabled/Pass is good"
    },
    {
      "telemetryName": "GPU_Stress_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "GPU_Memory_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "GPU_Stress_Test_Duration_Min",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 60,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "ECC_Delta_During_Test",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "XID_Delta_During_Test",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 95,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 5,
      "penaltyPerUnit": 25,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Temperature_Max_During_Test_C",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 70,
      "ruleMode": "Threshold_High",
      "goodThreshold": 45,
      "criticalThreshold": 55,
      "penaltyPerUnit": 0,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "Clock_Stability_During_Test_Percent",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 0,
      "ruleMode": "Context",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Context only"
    },
    {
      "telemetryName": "Power_Stability_During_Test_Percent",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 70,
      "ruleMode": "Penalty_Count",
      "goodThreshold": 0,
      "criticalThreshold": 10,
      "penaltyPerUnit": 10,
      "scoreDirection": "Lower is better"
    },
    {
      "telemetryName": "PCIe_Bandwidth_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "NVLink_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "CPU_Stress_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "Memory_Stress_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "Storage_Short_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "Cold_Boot_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "Warm_Reboot_Test_Result",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    },
    {
      "telemetryName": "All_GPUs_Detected_After_Test",
      "parentFeature": "Validation_Test_Health",
      "parentCategory": "Validation_Health",
      "fieldWeight": 100,
      "ruleMode": "PassFail",
      "goodThreshold": 1,
      "criticalThreshold": 0,
      "penaltyPerUnit": 10,
      "scoreDirection": "1=pass, 0=fail"
    }
  ]
};
